<!-- components/Header.vue -->
<template>
  <header :class="{ scrolled: isScrolled }">
    <div class="navbar-brand">
      <img
        :src="logo"
        @mouseover="logo = logo_blue"
        @mouseout="logo = logo_white"
        alt=""
        style="padding: 0; height: 1.6rem"
      />
    </div>
    <nav class="nav-links">
      <a href="#" v-if="isScrolled">{{ lMessages["link"] }}</a>
      <a href="#services" v-if="isScrolled">{{ lMessages["linkServices"] }}</a>
      <a href="#platform" v-if="isScrolled">{{ lMessages["linkPlatform"] }}</a>
      <a href="#aboutUs" v-if="isScrolled">{{ lMessages["linkUs"] }}</a>
      <a>
        <router-link :to="{ name: 'login' }">
          <button class="signup-btn">
            {{ lMessages["linkLogin"] }}
          </button>
        </router-link>
      </a>
      <a>
        <router-link :to="{ name: 'register' }">
          <button class="demo-btn">
            {{ lMessages["LinkRegister"] }}
          </button>
        </router-link>
      </a>
      <a v-if="language === 'es'" class="nav-item" href="/landing/en">EN</a>
      <a v-else class="nav-item" href="/landing/es">ES</a>
    </nav>
  </header>
</template>

<script>
export default {
  props: {
    isScrolled: { required: true, type: Boolean, default: false },
    language: { required: true, default: "en" },
    lMessages: { required: true }
  },
  data() {
    return {
      logo_white: require("@/assets/images/QuanspireLogoWhite.svg"),
      logo_blue: require("@/assets/images/QuanspireLogoBlue.svg"),
      logo: require("@/assets/images/QuanspireLogoWhite.svg")
    };
  }
};
</script>

<style scoped>
header {
  position: fixed;
  top: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 5%;
  padding-right: 5%;
  transition: all 0.3s ease;
  z-index: 1000;
}

header:not(.scrolled) {
  background: transparent !important;
}

header.scrolled {
  background: var(--lightBackgroundFixed);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.nav-links {
  height: 3.3rem;
  display: flex;
  gap: 1.5rem;
  align-items: center;
}

.nav-links a {
  color: var(--white);
  text-decoration: none;
  font-weight: 500;
  cursor: pointer;
}
a:hover {
  text-decoration: underline;
}

.signup-btn,
.demo-btn {
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 25px;
  color: var(--white);
  transition: transform 0.2s;
  cursor: pointer;
}

.signup-btn {
  background: var(--logo-blue);
}

.signup-btn:hover {
  transform: scale(1.05);
}

.demo-btn {
  background: var(--graylightbackgroundFixed);
}

.demo-btn:hover {
  transform: scale(1.05);
}
</style>
